<template>
  <q-popover>
    <q-list link>
      <q-item class="item item-link" v-close-overlay @click.native="handleExportCustomer">
        <q-item-side>
          <q-icon name="cloud_download"/>
        </q-item-side>

        <q-item-main>
          <span>{{ this.exportButtonText }}</span>
        </q-item-main>
      </q-item>

      <q-item-separator/>

      <q-item v-if="singleCustomer" class="item item-link" v-close-overlay v-is-user @click.native="handleEditCustomer">
        <q-item-side>
          <q-icon name="edit"/>
        </q-item-side>

        <q-item-main>
          <span>{{ $t('edit') }}</span>
        </q-item-main>
      </q-item>

      <q-item v-if="customers.length" class="item item-link" v-close-overlay v-is-user @click.native="handleDeleteCustomer">
        <q-item-side>
          <q-icon name="delete"/>
        </q-item-side>

        <q-item-main>
          <span>{{ $t('remove') }}</span>
        </q-item-main>
      </q-item>
    </q-list>
  </q-popover>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { CustomersClient } from 'src/api/Customers'
  import FileSaver from 'file-saver'
  import { general } from 'src/config'
  import { getCustomerName } from 'src/utils/searchResultParser'

  export default {
    props: {
      customers: {
        type: Array,
        default: () => []
      },

      multiple: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters(['selectedCustomer', 'activeTeam']),

      singleCustomer () {
        return this.customers.length === 1
      },

      multipleCustomers () {
        return this.customers.length > 1
      },

      exceedsShowLimit () {
        return this.customers.length > general.show_limit
      },

      customer () {
        return this.customers[0]
      },

      customerName () {
        return getCustomerName(this.customer)
      },

      exportButtonText () {
        return this.customers.length === 0 ? this.$t('export_all')
        : this.multiple ? (this.exceedsShowLimit ? this.$t('export_all') : this.$t('export_selected')) : this.$t('export')
      }
    },

    methods: {
      ...mapActions([
        'deleteCustomer',
        'deleteCheckedCustomers',
        'deselectCustomer',
        'setOpenEditCustomerModal',
        'openCustomerExportModal'
      ]),

      handleExportCustomer () {
        if (!this.exceedsShowLimit && (this.multipleCustomers || this.singleCustomer)) {
          return new CustomersClient()
            .export(this.customers.map(customer => customer.id))
            .then(response => {
              let blob = new Blob([response.data], { type: 'text/x-vcard' })

              FileSaver.saveAs(blob, (this.singleCustomer ? this.customerName : this.$tc('partner', 2)) + '.vcf')
            })
        }

        this.openCustomerExportModal()
      },

      handleEditCustomer () {
        this.setOpenEditCustomerModal({ type: this.customer.type, id: this.customer.id })
      },

      handleDeleteCustomer () {
        this.$q.dialog({
          title: this.singleCustomer ? this.$t('confirm_partner_delete_title')
          : this.$tc('confirm_checked_partners_delete_title', 1),
          message: this.singleCustomer ? this.$t('confirm_partner_delete_body', { name: this.customerName })
          : this.$tc('confirm_checked_partners_delete_title', 1),
          ok: this.$t('confirm'),
          cancel: this.$t('abort')
        })
          .then(() => {
            if (this.singleCustomer) {
              return this.deleteCustomer({ type: this.customer.type, customerId: this.customer.id })
            }

            return this.deleteCheckedCustomers()
          })
          .then(() => {
            if (this.selectedCustomer && this.selectedCustomer.id === this.customer.id) {
              this.$router.push({ name: 'customers', params: { teamId: this.activeTeam.id } })
              this.deselectCustomer()
            }
          })
      }
    }
  }
</script>
